import styles from "css/pages/activity/ActivityNotificationUnseenIndicator.module.css";

export default function ActivityNotificationUnseenIndicator(): JSX.Element {
  return <div className={styles.indicator} />;
}
